import { SlotStatus, SlotInfo, CalDateInfo } from '../../../types/schedule.types';
import { normalizeToSortedIds } from '../../../utils/calDateSlotsSortUtils';
import type { ClipboardScheduleItem } from './useScheduleClipboard';

export interface RestoreClipboardItemsParams {
  scheduleID: string;
  targetDateStr: string;
  items: ClipboardScheduleItem[];
  /** 剪贴组来源日的 calDateShift；仅当目标日排班为空时写入目标日 */
  sourceCalDateShift?: string;
  getDateCalDate: (dateStr: string) => CalDateInfo | undefined;
  createSlotData: (
    scheduleID: string,
    data: Partial<SlotInfo>,
  ) => Promise<string | undefined>;
  updateCalDateSlotsSort: (
    dateStr: string,
    additionalSoltIds?: string[],
    excludeSoltIds?: string[],
    replaceIds?: string[],
    calDateShift?: string,
  ) => Promise<void>;
}

/**
 * 将剪贴板条目按顺序恢复到某日（与「全部加到今日」内层逻辑一致，含 shift / visibility）
 */
function calDateShiftIsEmpty(shift: string | undefined): boolean {
  return shift === undefined || shift === null || String(shift).trim() === '';
}

export async function restoreClipboardItemsToDate(
  p: RestoreClipboardItemsParams,
): Promise<void> {
  const {
    scheduleID,
    targetDateStr,
    items,
    sourceCalDateShift,
    getDateCalDate,
    createSlotData,
    updateCalDateSlotsSort,
  } = p;

  const targetPd = getDateCalDate(targetDateStr);
  const targetShiftEmpty = calDateShiftIsEmpty(targetPd?.calDateShift);
  const effectiveCalDateShift =
    targetShiftEmpty && !calDateShiftIsEmpty(sourceCalDateShift)
      ? sourceCalDateShift
      : undefined;

  let currentFlat = normalizeToSortedIds(getDateCalDate(targetDateStr)?.calDateSlotsSort);
  for (const item of items) {
    const newSlotIds: string[] = [];
    for (const pt of item.slots) {
      const newId = await createSlotData(scheduleID, {
        slotType: pt.slotType,
        slotName: pt.slotName,
        slotSceneCode: pt.slotSceneCode,
        slotBelongSceneID: pt.slotBelongSceneID,
        slotBelongScheduleID: scheduleID,
        slotBelongBreakdownID: pt.slotBelongBreakdownID,
        slotLocation: pt.slotLocation,
        slotStatus: pt.slotStatus ?? SlotStatus.PREPARING,
        slotDate: targetDateStr,
        slotEndDay: targetDateStr,
        slotShift: pt.slotShift ?? undefined,
        slotLocationVisibility: pt.slotLocationVisibility ?? undefined,
      });
      if (newId) newSlotIds.push(newId);
    }
    if (newSlotIds.length > 0) {
      currentFlat = [...currentFlat, ...newSlotIds];
      await updateCalDateSlotsSort(targetDateStr, undefined, undefined, currentFlat);
    }
  }

  if (effectiveCalDateShift !== undefined) {
    await updateCalDateSlotsSort(
      targetDateStr,
      undefined,
      undefined,
      currentFlat,
      effectiveCalDateShift,
    );
  }
}
